<template>
  <el-dialog
    title="人工账户充值"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="depositForm"
      :model="form"
      :rules="rules"
      label-width="120px"
      v-loading="submitLoading"
    >
      <el-form-item label="公司名称：">
        <el-input v-model="form.companyName" disabled></el-input>
      </el-form-item>
      
      <el-form-item label="充值金额(元)：" prop="amount">
        <el-input 
          v-model="form.amount" 
          type="number"
          placeholder="请输入充值金额"
        ></el-input>
        <div v-if="form.amount > 10000" style="color: red; font-size: 12px; margin-top: 5px;">
          充值金额过大，请确认充值金额
        </div>
      </el-form-item>
      
      <el-form-item label="交易流水号：" prop="tradeNo">
        <el-input 
          v-model="form.tradeNo" 
          placeholder="请输入充值交易流水号"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="支付凭证：" prop="payVoucherUrl">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :show-file-list="false"
          name="fileVal"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div v-if="form.payVoucherUrl" style="margin-top: 10px;">
          <el-button size="mini" @click="viewVoucher">查看凭证</el-button>
        </div>
      </el-form-item>
      
      <el-form-item label="操作员：">
        <el-input v-model="form.operator" disabled></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">
        {{ submitLoading ? '充值中...' : '充 值' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getPaGxbUserInfo, manualPaGxbUserDeposit, getAdminInfo } from '@/api/member'

export default {
  name: 'WccyrDeposit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      submitLoading: false,
      form: {
        companyName: '',
        amount: '',
        tradeNo: '',
        payVoucherUrl: '',
        operator: ''
      },
      rules: {
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' }
        ],
        tradeNo: [
          { required: true, message: '请输入充值交易流水号', trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.resetForm()
      
      // 获取操作员信息
      try {
        const res = await getAdminInfo()
        if (res.err_code === 0) {
          this.form.operator = res.data.username
        } else {
          this.form.operator = '管理员'
        }
      } catch (error) {
        console.error('获取操作员信息失败:', error)
        this.form.operator = '管理员'
      }
      
      // 获取用户信息
      if (this.userId) {
        try {
          const res = await getPaGxbUserInfo({ id: this.userId })
          if (res.err_code === 0) {
            this.form.companyName = res.data.company_name
          }
        } catch (error) {
          console.error('获取用户信息失败:', error)
        }
      }
    },

    // 重置表单
    resetForm() {
      this.$refs.depositForm && this.$refs.depositForm.resetFields()
      this.form.companyName = ''
      this.form.amount = ''
      this.form.tradeNo = ''
      this.form.payVoucherUrl = ''
      this.form.operator = ''
    },

    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.form.payVoucherUrl = response.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.err_msg || '上传失败')
      }
    },

    // 上传失败回调
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },

    // 查看支付凭证
    viewVoucher() {
      if (this.form.payVoucherUrl) {
        window.open(this.form.payVoucherUrl, '_blank')
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.depositForm.validate(async (valid) => {
        if (valid) {
          // 检查充值金额是否为空
          if (!this.form.amount) {
            this.$message.warning('请输入充值金额')
            return
          }
          
          if (!this.form.tradeNo) {
            this.$message.warning('请填写充值交易流水号')
            return
          }
          
          // 检查支付凭证是否已上传
          if (!this.form.payVoucherUrl) {
            this.$message.warning('请上传支付凭证')
            return
          }
          
          // 检查充值金额是否过大
          if (this.form.amount > 10000) {
            try {
              await this.$confirm('充值金额过大，请确认充值金额', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
            } catch {
              return // 用户取消操作
            }
          }
          
          this.submitLoading = true
          try {
            const params = {
              user_id: this.userId,
              amount: Math.round(this.form.amount * 100), // 转换为分
              trade_no: this.form.tradeNo,
              pay_voucher_url: this.form.payVoucherUrl,
              source: 1  // 无车承运人用户充值时固定为1
            }
            
            // 使用无车承运人用户的人工充值接口
            const res = await manualPaGxbUserDeposit(params)
            if (res.err_code === 0) {
              this.$message.success('充值成功')
              this.$emit('success')
              this.handleClose()
            } else if (res.err_code === 1002) {
              this.$message.error('没有操作权限')
            } else if (res.err_code === 1010) {
              this.$message.error('用户不存在')
            } else {
              this.$message.error(res.err_msg || '充值失败')
            }
          } catch (error) {
            console.error('充值失败:', error)
            this.$message.error('充值失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.upload-demo {
  /deep/ .el-upload-list {
    display: none;
  }
}
</style>